export const DhwValveStates = [
    "UNKNOWN_DHW_VALVE_STATE",
    "FAULT",
    "CENTRAL_HEATING",
    "MOVING_TO_CENTRAL_HEATING",
    "MOVING_TO_DOMESTIC_HOT_WATER",
    "DOMESTIC_HOT_WATER",
]
